'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var i18n = require('@nuklear9/i18n');
var ui = require('@nuklear9/ui');
var React = require('react');
var reactQuery = require('react-query');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PageWrapper = ({ pageContext, children }) => {
  const locale = pageContext.locale || "de";
  const messages = i18n.useMessages(locale);
  const queryClient = new reactQuery.QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        keepPreviousData: true,
        cacheTime: 1e3 * 60 * 60 * 2,
        // 2 hours
        staleTime: 1e3 * 60 * 60 * 2
        // 2 hours
      }
    }
  });
  return /* @__PURE__ */ React__default["default"].createElement(
    i18n.IntlProvider,
    {
      defaultLocale: "de",
      locale,
      messages
    },
    /* @__PURE__ */ React__default["default"].createElement(ui.CookieConsentProvider, null, /* @__PURE__ */ React__default["default"].createElement(reactQuery.QueryClientProvider, { client: queryClient }, children))
  );
};
const WrapPageElement = ({
  element,
  props
}) => /* @__PURE__ */ React__default["default"].createElement(PageWrapper, { pageContext: props.pageContext }, element);

const wrapPageElement = WrapPageElement;

exports.wrapPageElement = wrapPageElement;
